import * as React from "react";
const SvgAgentChatStopProcessing = props => <svg fill="none" height={24} width={24} xmlns="http://www.w3.org/2000/svg" {...props}><rect fill="#fff" height={10} rx={1} width={10} x={7} y={7} /></svg>;
export default SvgAgentChatStopProcessing;